<div class="container-fluid text-basic bg-dark-gray-content py-3 px-2 rounded-1">
  @if (term) {
    <div class="row justify-content-center p-4 rounded-4">
      <div class="col-12">
        <div
          #contentScrollPanel
          class="terms-conditions-modal__content-scroll theme-scrollbar"
        >
          <section class="terms-conditions-modal__term">
            <h1 class="fs-3 fw-bold text-center text-basic mb-0">{{ term.title }}</h1>
            <hr class="my-3 terms-conditions-modal__hr" />
            <div
              class="terms-conditions-modal__html terms-conditions-modal__rich-html text-start text-basic"
              [innerHTML]="term.content | sanitizeHtml"
            ></div>
          </section>

          <div class="terms-conditions-modal__actions text-center">
            @if (confirmRequestFailed()) {
              <p class="text-danger small mb-3">{{ "termsConditions.saveError" | translate }}</p>
            }
            <button
              appButton
              variant="primary"
              type="button"
              [class.me-3]="showCancelButton"
              [disabled]="isSubmitting()"
              (click)="onConfirm()"
            >
              {{
                (isSubmitting() ? "termsConditions.saving" : "termsConditions.accept") | translate
              }}
            </button>

            @if (showCancelButton) {
              <button
                appButton
                variant="secondary"
                type="button"
                [disabled]="isSubmitting()"
                (click)="onCancel()"
              >
                {{ "termsConditions.cancel" | translate }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="text-center py-4">
      <p class="text-danger mb-3">{{ "termsConditions.loadError" | translate }}</p>
      <button
        appButton
        variant="primary"
        type="button"
        (click)="onCancel()"
      >
        {{ backLabelKey | translate }}
      </button>
    </div>
  }
</div>
